import { render, staticRenderFns } from "./MddPasoProfundiza.vue?vue&type=template&id=5f724aaf&"
import script from "./MddPasoProfundiza.vue?vue&type=script&lang=js&"
export * from "./MddPasoProfundiza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports